var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDast2Bahamchist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 595.3 841.9"
    },
    xmlSpace: "preserve",
    viewBox: "162.98 381.17 269.97 78.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.4;fill:#FE4800;enable-background:new    ;}\n\t.st2{fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hand_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413.5,429.6c-5.4,5.4-21.7,13.1-27.6,17.3c-4.1,2.9-21.4,5.6-26.4,7.1c-3.6,1.1-8.3,5.1-13.1,3.8    c-4.8-1.4-44.3-20.4-53.8-25.1c-9.5-4.8-58.6,2.7-87.8,1.7c-1.9-0.1-3.7-0.1-5.5-0.2c-25.2-0.7-34.9,0.2-34.9,0.2l13.5-52    c0,0,24.9,1.2,62.9,7.9c7.7,1.4,14.6,2.4,20.8,3.3c24.6,3.5,37.7,3.8,37.7,3.8s12.7-11,24.5-1.6c11.9,9.4,15,17.4,15,17.4    l16.6,9.5c0,0,6.7-1.2,10.9,0c4.1,1.2,10-2.8,13-4.4c3.9-2,10.2-4.4,16.9-5.1c0,0,10.2-4,17.8-2c0,0,5.5-2.4,10.3-2.4    c1.4,0,2.6,0.3,3.6,0.7c2.2,1,3.2,2.6,3.2,2.6s0.4,1.4,0.8,4.2C432.3,419.2,425.6,417.4,413.5,429.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.5,429.6c-5.4,5.4-21.7,13.1-27.6,17.3c-4.1,2.9-21.4,5.6-26.4,7.1c-3.6,1.1-8.3,5.1-13.1,3.8     c-4.8-1.4-44.3-20.4-53.8-25.1c-9.5-4.8-58.6,2.7-87.8,1.7c-1.9-0.1-3.7-0.1-5.5-0.2c12.7-0.8,26-1.8,30.1-2.5     c8.4-1.4,50.5-3.6,56.4-4.1c5.8-0.5,52,23.5,57.3,25.9c5.3,2.4,9,2.6,12.4,0s17.1-5,17.1-5l-7.9,0.7c0,0,10.4-3.8,17.2-5.5     c6.8-1.7,13.5-7.8,18-9.2c4.5-1.4,12.3-10.3,16.2-12.1c3.9-1.8,0-7.3,0-7.3s4.7-0.2,6.6,2.8c0,0,6.9,0.2,8.3-5.7     c0,0,0.4,1.4,0.8,4.2C432.3,419.2,425.6,417.4,413.5,429.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428,409.6c-11.4,3-13.9,4.9-13.9,4.9c-2.1-0.6-15.6,7.9-16.7,8.6c-1.2,0.7-1.8,4-1.8,4s-3.9-4-10.5,0.6     s-7.3,7.4-7.3,7.4l-2.6-3.4c0,0-11.2,1-14.6,0.4c-3.4-0.5-5.2-1.3-7.8-3.1c-2.6-1.7-16.5-7.6-17.9-8s-3.2-3.1-3.2-3.1     c-2.5-10.2-15.1-21.8-22-20.8c-6.9,0.9-11.4,4.6-11.4,4.6s-12.8-1.3-19.4-1.6c-6.6-0.3-46.7-7.6-46.7-7.6l29.6,1     c24.6,3.5,37.7,3.8,37.7,3.8s12.7-11,24.5-1.6c11.9,9.4,15,17.4,15,17.4l16.6,9.5c0,0,6.7-1.2,10.9,0c4.1,1.2,10-2.8,13-4.4     c3.9-2,10.2-4.4,16.9-5.1c0,0,10.2-4,17.8-2c0,0,5.5-2.4,10.3-2.4C425.9,408.9,427,409.2,428,409.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.7,425.4c0,0,0.1,2.8-1.4,2.5s2.6,3.9,5.3,3.2c2.6-0.7,9.1,5.3,11.6,7.9s24.3,6.1,29,5.9     c4.6-0.1,8.2-4.9,4.9-9.8c0,0-0.6,4.8-3.5,4.3c0,0,2.8-1.1-1.4-5c-4.2-4-10.4-5.7-11.7-4.9c-1.3,0.8-9.3-2.5-9.8-3     s0.7,11.4-6.3,11c0,0-7.8-5.8-9.4-8.2C315.4,427.1,309.7,425.4,309.7,425.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.9,382.4c0,0,24.9,1.2,62.9,7.9c38,6.7,58.5,7.1,58.5,7.1s12.7-11,24.5-1.6c11.9,9.4,15,17.4,15,17.4     l16.6,9.5c0,0,6.7-1.2,10.9,0c4.2,1.2,10-2.8,13-4.4c3.9-2,10.2-4.4,16.9-5.1c0,0,10.2-4,17.7-2c0,0,5.5-2.4,10.3-2.4     c4.7,0,6.7,3.4,6.7,3.4s0.4,1.4,0.8,4.2s-6.3,1-18.4,13.2c-5.4,5.4-21.7,13.1-27.6,17.3c-4.1,2.9-21.4,5.6-26.4,7.1     c-3.6,1-8.3,5.1-13.1,3.8c-4.7-1.4-44.3-20.3-53.8-25.1c-9.5-4.7-58.5,2.7-87.8,1.7s-40.4,0-40.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M363.1,429.7c1.4,0,12.3,0,12.3,0s10.5-4,18.4-6.1c0,0,11.5-7.5,15.2-8.7c3.8-1.2,8.1,0,9.7,2.2s1.6,5,1.6,5     s-11.1,7.3-14.2,10c-3.2,2.8-9.9,5.3-17.2,10.1c-7.3,4.7-20.6,5-25.7,7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M414.1,411.3c0,0-12.8,4.7-18.7,11.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M391.7,423.1c0,0-9.6,2.6-16.5,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368.6,422.9c0,0-0.9,1.2,0,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.3,424.8c0,0,4.7,2.1,7.3,3.5s5.6,8.2,9.1,9.8c3.5,1.6,8.9,2.3,16,3.3s16.6,2.8,18.2-3.5     c1.6-6.2-9.2-10.3-14.7-13.1c-5.5-2.8-9.3-3.6-9.3-3.6s-2.7-2.6-3.7-3.6s-1-6.1-2-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M333.7,411.3c0,0-0.3,4.4-2.1,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M352.8,427.1c0,0,1.1-2.9,2.8-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M306.9,427.7c0,0,5.3,1.2,7.6,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M336.1,416.3c0,0-0.6,1.7-2.9,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M331.6,427.7c0,0,0.8,5.3-3.8,8.1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDast2Bahamchist);
export default __webpack_public_path__ + "static/media/dast2bahamchist.236b9914d95c5ee93e1d74e7c19b0b41.svg";
export { ForwardRef as ReactComponent };